import React from "react";
import { View, Text, StyleSheet, ScrollView, Image, TextInput } from "react-native";
import { useTranslation } from "react-i18next";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import EnglishFlag from "../../../../../../../../assets/images/english-flag.png";
import Colors from "../../../../../constants/colors";
import GradientBackground from '../../../../uiComponents/GradientBackground';

type Props = {};

export default function PayAmountStep() {
  const { t } = useTranslation();
  const sendAmount = useSessionStore((s: SessionState) => s.currentSendAmount);
  const setCurrentSendAmount = useSessionStore((s: SessionState) => (s as any).setCurrentSendAmount);

  const parseAmount = (text: string): string => {
    // allow only digits and one optional decimal point
    const cleaned = text.replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      return `${parts[0]}.${parts.slice(1).join("")}`;
    }
    return cleaned;
  };

  return (
    <View style={styles.container}>
      <View style={{ alignItems: 'center'}}>
        <Text style={styles.title}>{t("PAY_AMOUNT")}</Text>
        <View style={styles.amountInput}>
          <TextInput
            autoFocus
            style={styles.amountText}
            keyboardType="decimal-pad"
            placeholder="0.00"
            value={sendAmount}
            onChangeText={(t) => {
              const next = parseAmount(t);
              // setSendAmount(next);
              setCurrentSendAmount?.(next);
            }}
          />
          <View style={{ marginLeft: 8, alignItems: 'center', justifyContent: 'center'}}>
            <Image source={EnglishFlag} style={{ width: 16, height: 16}}/>
            <Text style={styles.currencyText}>USD</Text>
          </View>
        </View>
        <Text style={[styles.subtitle, {marginBottom: 16}]}>{t("PAYMENT_RECEIVED_INFORMATION")}</Text>
        <Text style={styles.subtitle}>{t("PAYMENT_POST")}</Text>
      </View>

      <GradientBackground style={styles.card}>
        <View style={styles.row}>
          <Text style={styles.feeLabel}>{t("REVIEW_TOTAL")}</Text>
          <View style={{ flexDirection: 'row'}}>
            <Text style={styles.oldPrice}>{sendAmount}USD</Text>
          </View>
        </View>
      </GradientBackground>
    </View>
  );
}


const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
  },
  amountInput: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
    marginBottom: 200
  },
  amountText: {
    fontFamily: 'Rubik',
    fontSize: 40,
    fontWeight: "500",
    textAlign: "center",
    color: Colors.titleTextColor,
    lineHeight: 46,
    width: 200
  },
  currencyText: {
    fontFamily: 'Rubik',
    fontSize: 14,
    fontWeight: "500",
    textAlign: "center",
    color: Colors.subTitleColor,
    lineHeight: 22
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 32,
    paddingBottom: 40,
  },
  title: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "500",
    textAlign: "center",
    color: Colors.subTitleColor,
    lineHeight: 24,
    marginTop: 32,
  },
  subtitle: {
    fontFamily: 'Rubik',
    fontSize: 12,
    fontWeight: "400",
    textAlign: "left",
    color: Colors.infoSubValue,
    paddingLeft: 24,
    paddingRight: 90,
    lineHeight: 16
  },
    card: {
    alignItems: "center",
    marginHorizontal: 24
    // width: 327,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  feeLabel: {
    fontSize: 16,
    fontWeight: "500",
  },
  oldPrice: {
    fontSize: 16,
    // textDecorationLine: "line-through",
    marginRight: 8,
  },
  newPrice: {
    fontSize: 16,
    fontWeight: "bold",
    color: "green",
  },
});